import { cn } from '@ahm/common-helpers';
import type { ReactNode } from 'react';

interface HeaderBackgroundProps {
  children: ReactNode;
  className?: string;
}

/**
 * Ambient backdrop cho mobile homepage header.
 *
 * Hiện dùng CSS gradient + subtle pattern (fallback). Khi designer cung cấp
 * SVG decoration, swap nội dung của `<div aria-hidden>` bên dưới — props
 * giữ nguyên nên các call site không cần đổi.
 */
export function HeaderBackground({
  children,
  className,
}: HeaderBackgroundProps) {
  return (
    <div className={cn('relative overflow-hidden overflow-x-clip', className)}>
      <div
        aria-hidden
        className="absolute inset-0 -z-10"
        style={{
          background:
            'linear-gradient(180deg, rgba(255, 127, 50, 0.18) 0%, rgba(255, 255, 255, 0) 100%), #FFFFFF',
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0 -z-10 opacity-40"
        style={{
          backgroundImage:
            'radial-gradient(circle at 12% 20%, rgba(255, 188, 47, 0.25) 0%, transparent 40%), radial-gradient(circle at 92% 8%, rgba(234, 63, 237, 0.12) 0%, transparent 38%)',
        }}
      />
      {children}
    </div>
  );
}
